import { render, staticRenderFns } from "./DIsputeResolutionMessagesDetails.vue?vue&type=template&id=be89671e&scoped=true&"
import script from "./DIsputeResolutionMessagesDetails.vue?vue&type=script&lang=js&"
export * from "./DIsputeResolutionMessagesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be89671e",
  null
  
)

export default component.exports